import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AAGoogleMapModule } from '../google-map/aa-google-map.module';
import { AaSignpostListComponent } from './components/route-signposts/aa-signposts/aa-signpost-list/aa-signpost-list.component';
import { RoutePlannerPrintViewComponent } from './components/route-planner-print-view/route-planner-print-view.component';
import { AACoreModule } from '../aa-core/aa-core.module';
import { CUSTOM_COMPONENTS_LIST } from './components';
import { RoutePrintPreviewComponent } from './components/route-print-preview/route-print-preview.component';
import { AppRoutingModule } from '../app-routing/app-routing.module';

@NgModule({
  declarations: [
    CUSTOM_COMPONENTS_LIST,
    RoutePrintPreviewComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    AAGoogleMapModule,
    AACoreModule,
    AppRoutingModule
  ],
  exports: [
    AaSignpostListComponent,
    RoutePlannerPrintViewComponent,
    RoutePrintPreviewComponent
  ]
})
export class RoutePlannerModule { }
